/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import {
  Switch,
  Route,
  withRouter,
  Redirect,
  Link,
  NavLink,
} from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';

import CmsContext from '../../../context/CmsContext';

import AllTransactions from './containers/AllTransactions';
import RPTReports from './containers/RPTReports';
import BTAXReports from './containers/BTAXReports';
import CivilRegistryReports from './containers/CivilRegistryReports';
import CedulaTransactions from './containers/CedulaTransactions';
import OVRSReports from './containers/OVRSReports';
import OHPReports from './containers/OHPReports';
import BPLSReports from './containers/BPLSReports';
import BPLSE2EReports from './containers/BPLSE2EReports';
import NOVReports from './containers/NOVReports';
import HealthReports from './containers/HealthReports';
import SideScrollingTab from '../../common/components/SideScrollingTab';
// import ComputerFeeReports from './containers/ComputerFeeReports';
import AgencyReports from './containers/AgencyReports';

function TransactionsContainer({ match, pathName, permissions }) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  return (
    <React.Fragment>
      <div className="module-inner">
        <SideScrollingTab dragToScroll hideScrollButtons>
          <div className="report-module-nav mb-3">
            {Acl(permissions, ['VIEW ALL REPORTS']) && (
              <NavLink
                exact
                className="nav-link py-2"
                activeClassName="active"
                to={`${match.path}/all`}
              >
                All
              </NavLink>
            )}
            {/* {Acl(permissions, ['VIEW BPLS REPORTS', 'VIEW ALL REPORTS']) && !_.get(CMS_COMPONENTS, "BPLS_SERVICES_SUB_MENU") && (
              <NavLink
                exact
                className="nav-link py-2"
                activeClassName="active"
                to={`${match.path}/bpls`}
              >
                E-BOSS
              </NavLink>
            )} */}
            {/* {Acl(permissions, ['VIEW BPLS REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(CMS_COMPONENTS, 'BPLS_SERVICES_SUB_MENU') && ( // todo: update ACL to VIEW GO!BPLS REPROTS
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/go-bpls`}
                >
                  Business Permit and License Application (BPLS)
                </NavLink>
              )} */}
            {Acl(permissions, ['VIEW BTAX REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(
                CMS_COMPONENTS,
                'BPLS_SERVICEBTAX_SERVICES_SUB_MENUS_SUB_MENU'
              ) && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/btax`}
                >
                  BTAX
                </NavLink>
              )}
            {/* {Acl(permissions, ['VIEW CEDULA REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(CMS_COMPONENTS, 'CEDULA_SERVICES_SUB_MENU') && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/community-tax-certificate`}
                >
                  CEDULA
                </NavLink>
              )} */}
            {/* {Acl(permissions, [
              'VIEW CIVIL REGISTRY REPORTS',
              'VIEW ALL REPORTS',
            ]) &&
              !_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_SERVICES_SUB_MENU') && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/local-civil-registry`}
                >
                  CIVIL REGISTRY
                </NavLink>
              )} */}

            {/* TODO: Add ACL on this tab */}
            {/* {Acl(permissions, [
              'VIEW CIVIL REGISTRY REPORTS',
              'VIEW ALL REPORTS',
            ]) &&
            !_.get(CMS_COMPONENTS, "CIVIL_REGISTRY_SERVICES_SUB_MENU") && ( */}
            {/* <NavLink
              exact
              className="nav-link py-2"
              activeClassName="active"
              to={`${match.path}/computer-fee`}
            >
              COMPUTER FEE
            </NavLink> */}
            {/* )} */}
            {/* <NavLink
              exact
              className="nav-link py-2"
              activeClassName="active"
              to={`${match.path}/agency-reports`}
            >
              AGENCY REPORTS
            </NavLink> */}

            {Acl(permissions, ['VIEW NOV REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(CMS_COMPONENTS, 'NOVS_SERVICES_SUB_MENU') && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/nov`}
                >
                  NOV
                </NavLink>
              )}
            {Acl(permissions, ['VIEW OHP REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(CMS_COMPONENTS, 'NOVS_SERVICES_SUB_MENU') && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/ohp`}
                >
                  OHP
                </NavLink>
              )}
            {Acl(permissions, [
              'VIEW HEALTH CERTIFICATE REPORTS',
              'VIEW ALL REPORTS',
            ]) &&
              !_.get(
                CMS_COMPONENTS,
                'HEALTH_CERTIFICATE_SERVICES_SUB_MENU'
              ) && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/hc`}
                >
                  Health Certificate
                </NavLink>
              )}
            {Acl(permissions, ['VIEW OVRS REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(CMS_COMPONENTS, 'OVRS_SERVICES_SUB_MENU') && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/ovrs`}
                >
                  OVRS
                </NavLink>
              )}
            {Acl(permissions, ['VIEW RPTAX REPORTS', 'VIEW ALL REPORTS']) &&
              !_.get(CMS_COMPONENTS, 'RPT_SERVICES_SUB_MENU') && (
                <NavLink
                  exact
                  className="nav-link py-2"
                  activeClassName="active"
                  to={`${match.path}/rptax`}
                >
                  RPTAX
                </NavLink>
              )}
          </div>
        </SideScrollingTab>
        <Switch>
          {Acl(permissions, ['VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/all`} />}
            />
          )}
          {Acl(permissions, ['VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/all`} component={AllTransactions} />
          )}
          {Acl(permissions, ['VIEW RPTAX REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/rptax`} />}
            />
          )}
          {Acl(permissions, ['VIEW RPTAX REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/rptax`} component={RPTReports} />
          )}
          {Acl(permissions, ['VIEW BTAX REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/btax`} />}
            />
          )}
          {Acl(permissions, ['VIEW BTAX REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/btax`} component={BTAXReports} />
          )}
          {Acl(permissions, ['VIEW OHP REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/ohp`} />}
            />
          )}
          {Acl(permissions, ['VIEW OHP REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/ohp`} component={OHPReports} />
          )}
          {Acl(permissions, [
            'VIEW HEALTH CERTIFICATE REPORTS',
            'VIEW ALL REPORTS',
          ]) && <Route path={`${match.path}/hc`} component={HealthReports} />}
          {Acl(permissions, ['VIEW OVRS REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/ovrs`} />}
            />
          )}
          {Acl(permissions, ['VIEW OVRS REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/ovrs`} component={OVRSReports} />
          )}
          {Acl(permissions, ['VIEW BPLS REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/bpls`} />}
            />
          )}
          {Acl(permissions, ['VIEW BPLS REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/bpls`} component={BPLSReports} />
          )}
          {/* E2E */}
          {Acl(permissions, ['VIEW BPLS REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/go-bpls`} />}
            />
          )}
          {Acl(permissions, ['VIEW BPLS REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/go-bpls`} component={BPLSE2EReports} />
          )}
          {Acl(permissions, [
            'VIEW CIVIL REGISTRY REPORTS',
            'VIEW ALL REPORTS',
          ]) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => (
                <Redirect to={`${match.path}/local-civil-registry`} />
              )}
            />
          )}
          {Acl(permissions, [
            'VIEW CIVIL REGISTRY REPORTS',
            'VIEW ALL REPORTS',
          ]) && (
            <Route
              path={`${match.path}/local-civil-registry`}
              component={CivilRegistryReports}
            />
          )}

          {/* {Acl(permissions, [
            'VIEW CIVIL REGISTRY REPORTS',
            'VIEW ALL REPORTS',
          ]) && ( */}
          {/* <Route
            path={`${match.path}/computer-fee`}
            component={ComputerFeeReports}
          /> */}
          {/* )} */}

          {Acl(permissions, ['VIEW CEDULA REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => (
                <Redirect to={`${match.path}/community-tax-certificate`} />
              )}
            />
          )}
          {Acl(permissions, ['VIEW CEDULA REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              path={`${match.path}/community-tax-certificate`}
              component={CedulaTransactions}
            />
          )}
          {Acl(permissions, ['VIEW NOV REPORTS', 'VIEW ALL REPORTS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/nov`} />}
            />
          )}
          {Acl(permissions, ['VIEW NOV REPORTS', 'VIEW ALL REPORTS']) && (
            <Route path={`${match.path}/nov`} component={NOVReports} />
          )}
          <Route
            path={`${match.path}/agency-reports`}
            component={AgencyReports}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

TransactionsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  permissions: getJson('permissions'),
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(TransactionsContainer);
